export const fridayUppercase = "xkKq5";
export default {fridayUppercase};